import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/", icon: "ri-home-5-line" },
  { label: "资讯", to: "/news", icon: "ri-newspaper-line" },
  { label: "原创", to: "/original", icon: "ri-quill-pen-line" },
  { label: "视频", to: "/video", icon: "ri-play-circle-line" },
  { label: "社区", to: "/community", icon: "ri-chat-smile-2-line" },
  { label: "关于", to: "/about", icon: "ri-information-line" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const submitSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/search?q=${encodeURIComponent(value)}` : "/search");
    setSearchOpen(false);
    setMenuOpen(false);
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="flex h-16 items-center justify-between gap-4 px-4 md:h-18 md:px-8">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50 dark:text-foreground-950">
            <i className="ri-emotion-happy-line text-xl"></i>
          </span>
          <span className="font-brand text-2xl leading-none text-primary-600 md:text-3xl">我爱搞</span>
        </Link>

        <nav className="hidden flex-1 items-center justify-center gap-1 lg:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `cursor-pointer whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <form onSubmit={submitSearch} className="hidden md:block">
            <div className="flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-1.5 focus-within:border-primary-300">
              <span className="flex h-5 w-5 items-center justify-center text-foreground-400">
                <i className="ri-search-line text-base"></i>
              </span>
              <input
                name="q"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索资讯、原创、视频"
                className="w-40 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none xl:w-56"
              />
            </div>
          </form>

          <button
            type="button"
            onClick={() => setSearchOpen((v) => !v)}
            aria-label="搜索"
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-foreground-700 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className="ri-search-line text-xl"></i>
          </button>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="菜单"
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-foreground-700 transition-colors hover:bg-background-100 lg:hidden"
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
          </button>
        </div>
      </div>

      {searchOpen ? (
        <form onSubmit={submitSearch} className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-2">
            <span className="flex h-5 w-5 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              autoFocus
              name="q"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索资讯、原创、视频"
              className="w-full bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none"
            />
            <button
              type="submit"
              className="cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50 dark:text-foreground-950"
            >
              搜索
            </button>
          </div>
        </form>
      ) : null}

      {menuOpen ? (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `flex cursor-pointer items-center gap-2 rounded-lg border px-3 py-2.5 text-sm font-medium transition-colors ${
                    isActive
                      ? "border-primary-200 bg-primary-100 text-primary-700"
                      : "border-background-200 bg-background-50 text-foreground-700"
                  }`
                }
              >
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className={`${item.icon} text-base`}></i>
                </span>
                {item.label}
              </NavLink>
            ))}
          </div>
        </nav>
      ) : null}
    </header>
  );
}